import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function aboutCard() {
  
    
      return (
        <div className='aboutCard'>
        <h1 style={{fontWeight:'bolder', fontSize:28}}>About us</h1>
        <div style={{textAlign:'horizontal', padding:10}}>
        <text style={{fontWeight:'bold', fontSize:22, fontFamily:'sans-serif', color:'orangered'}}>GLOBAL HEATING</text>
        <text style={{fontSize:20, fontWeight:'lighter', marginLeft:10, color:'rgb(50, 50, 50)'}}>is a specialized company in heating systems,helping our customers to have
a comfortable and relaxing life using high quality products in creative and decorative ways.</text>
        </div>

        <div style={{textAlign:'horizontal', padding:10}}>
        <text style={{fontWeight:'bold', fontSize:22, fontFamily:'sans-serif', color:'orangered'}}>Our Mission</text>
        <text style={{fontSize:20, fontWeight:'lighter', marginLeft:10, color:'rgb(50, 50, 50)'}}>Our team in a mission to provide the whole luxury life for
our customers which is making their life cozy and more
happier by keeping smart system for heating in winter so
the mission is not impossible.</text>
        </div>
        </div>
      );
    }
    
    

export default aboutCard;
